module.exports = __webpack_public_path__ + "static/media/113.8736600a.jpg";